const AppRoutes = {
  landingPage: '/',
  loginPage: '/login',
  notFound: '/404',
};

export default AppRoutes;
